import { render, staticRenderFns } from "./CreateApp.vue?vue&type=template&id=533d69f3&scoped=true"
import script from "./CreateApp.vue?vue&type=script&lang=ts"
export * from "./CreateApp.vue?vue&type=script&lang=ts"
import style0 from "./CreateApp.vue?vue&type=style&index=0&id=533d69f3&prod&lang=scss&scoped=true"
import style1 from "./CreateApp.vue?vue&type=style&index=1&id=533d69f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d69f3",
  null
  
)

export default component.exports